function artDownloadProgressDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/art-download-progress/art-download-progress-dialog.html?$$REVISION$$'
  }
}
export { artDownloadProgressDialog }
